import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/index.js';
export const ReadInvoiceByIdApiSchema = {
    params: z.object({
        entityId: CornSchema,
        invoiceId: z.string(),
    }),
    response: z.object({ invoice: InvoiceSchema }),
};
export const ReadInvoiceByIdPathSchema = ReadInvoiceByIdApiSchema.params;
export const ReadInvoiceByIdRequestSchema = ReadInvoiceByIdPathSchema;
export const ReadInvoiceByIdResponseSchema = ReadInvoiceByIdApiSchema.response;
